import { designTokens } from "@itandi/itandi-bb-ui";
import { Alert } from "@itandi/itandi-bb-ui/Alert";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";

type Props = {
	deleteCount: number;
	onClose: () => void;
	onDelete: () => void;
};

export function ReportBulkDeleteModal({
	deleteCount,
	onClose,
	onDelete
}: Props) {
	return (
		<Modalv2 isOpen onClose={onClose} size="s">
			<ModalHeader title="一括削除" />
			<ModalBody>
				{`${deleteCount}件の画像を削除します。`}
				<Alert mt={designTokens["spacing/m"]} variant="warning">
					他社がアップロードした画像は削除されません。
				</Alert>
			</ModalBody>
			<ModalFooter
				leftArea={
					<Button onClick={onClose} type="button" variant="secondary">
						キャンセル
					</Button>
				}
				rightArea={
					<Button
						onClick={() => {
							onClose();
							onDelete();
						}}
						type="button"
						variant="primary"
					>
						削除
					</Button>
				}
			/>
		</Modalv2>
	);
}
